module.exports = __webpack_public_path__ + "img/leader2.55d01558.jpg";